// Conversion tracking: GA4 + Meta Pixel + Google Ads
// IDs are read from env. Scripts only load if IDs are configured.

const GA4_ID = process.env.REACT_APP_GA4_ID;
const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const GADS_ID = process.env.REACT_APP_GADS_ID;
const GADS_LABEL = process.env.REACT_APP_GADS_LABEL;

let initialized = false;

export function initTracking() {
  if (initialized || typeof window === "undefined") return;
  initialized = true;

  // ---- Google Analytics 4 + Google Ads (same gtag.js) ----
  const gtagId = GA4_ID || GADS_ID;
  if (gtagId) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${gtagId}`;
    document.head.appendChild(s);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    if (GA4_ID) window.gtag("config", GA4_ID);
    if (GADS_ID) window.gtag("config", GADS_ID);
  }

  // ---- Meta (Facebook) Pixel ----
  if (META_PIXEL_ID) {
    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    window.fbq("init", META_PIXEL_ID);
    window.fbq("track", "PageView");
  }
}

// Fire lead conversion on every platform configured
export function trackLead({ value = 0, currency = "INR", plan = "" } = {}) {
  if (typeof window === "undefined") return;

  if (GA4_ID && window.gtag) {
    window.gtag("event", "generate_lead", {
      currency,
      value,
      plan,
    });
  }

  if (GADS_ID && GADS_LABEL && window.gtag) {
    window.gtag("event", "conversion", {
      send_to: `${GADS_ID}/${GADS_LABEL}`,
      value,
      currency,
    });
  }

  if (META_PIXEL_ID && window.fbq) {
    window.fbq("track", "Lead", { value, currency, content_name: plan });
  }
}
